import router from "./router/index";

const whiteList = ["/login"];

router.beforeEach((to, from, next) => {
  if (sessionStorage.getItem("token")) {
    if (from.path === "/getvideo") {
      // 如果是退出登录就放行
      if (to.path === "/login") {
        next();
      } else {
        // 从getvideo去其他页面不让去，还去getvideo
        next("/getvideo");
      }
    } else {
      next();
    }
  } else {
    // 没登录的话呢
    if (whiteList.includes(to.path)) {
      // 没登录但是要去的在白名单内 就让你去
      next();
    } else {
      // 否则就去登录
      next("/login");
    }
  }
});



// WEBPACK FOOTER //
// ./src/permission.js